// extracted by mini-css-extract-plugin
export default {"container":"styles_container__9i934","ttl":"styles_ttl__t-gqf","txt":"styles_txt__ylyzf"};